export default "38f8ad939b756803.svg"